var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.615,
    height: 32.615,
    viewBox: "0 0 32.615 32.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1670",
    "data-name": "Group 1670",
    transform: "translate(-394 -1082.471)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 16.307,
    cy: 16.307,
    r: 16.307,
    transform: "translate(394 1082.471)",
    fill: "#8c63ee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499",
    transform: "translate(-305.82 3494.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M708.235-2398.059a1.852,1.852,0,0,1,.42-.87,1.635,1.635,0,0,1,1.042-.524,1.2,1.2,0,0,0,.275-.075q4.982-1.859,9.963-3.72a.981.981,0,0,1,1.329.632q.517,1.521,1.029,3.044a.2.2,0,0,0,.171.157,1.6,1.6,0,0,1,1.248,1.531c.008.428,0,.857,0,1.285a.321.321,0,0,1-.366.36,1.837,1.837,0,0,0-.841.135,1.3,1.3,0,0,0-.715,1.333,1.276,1.276,0,0,0,1.119,1.1c.159.019.322.012.482.02a.3.3,0,0,1,.315.284,14.841,14.841,0,0,1-.03,1.6,1.557,1.557,0,0,1-1.482,1.33c-.191.008-.383.005-.574.005H710a1.614,1.614,0,0,1-1.747-1.375c0-.009-.011-.016-.017-.024v-1.6a.42.42,0,0,1,.438-.222,1.96,1.96,0,0,0,.376-.016,1.277,1.277,0,0,0,1.1-1.079,1.292,1.292,0,0,0-.688-1.344,1.5,1.5,0,0,0-.792-.141.425.425,0,0,1-.438-.222ZM723.063-2393a1.952,1.952,0,0,1-1.922-1.792,1.9,1.9,0,0,1,.4-1.329,1.954,1.954,0,0,1,1.534-.766c0-.3,0-.584,0-.871a.977.977,0,0,0-1.053-1.057h-7.978c0,.118,0,.213,0,.309a.318.318,0,0,1-.318.332.311.311,0,0,1-.322-.326c0-.1,0-.2,0-.3a.284.284,0,0,0-.057-.017c-1.189,0-2.378-.007-3.567,0a.9.9,0,0,0-.863.757,11.026,11.026,0,0,0-.009,1.158,1.979,1.979,0,0,1,1.915,1.956,1.985,1.985,0,0,1-1.94,1.943c0,.29,0,.581,0,.872a.977.977,0,0,0,1.047,1.049H713.4c0-.115,0-.215,0-.314a.311.311,0,0,1,.321-.326.318.318,0,0,1,.319.331c0,.1,0,.2,0,.31h8.022a.945.945,0,0,0,1-.876C723.086-2392.294,723.063-2392.642,723.063-2393Zm-1.43-6.466a.647.647,0,0,0-.016-.1q-.486-1.435-.975-2.871a.325.325,0,0,0-.467-.218c-.27.1-.537.2-.805.3l-7.516,2.808c-.045.017-.089.038-.134.056l.012.019Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M836.684-2250.244c0,.171,0,.343,0,.513a.322.322,0,0,1-.328.34.317.317,0,0,1-.312-.337q-.006-.529,0-1.057a.324.324,0,0,1,.325-.341.326.326,0,0,1,.314.339C836.687-2250.607,836.684-2250.426,836.684-2250.244Z",
    transform: "translate(-122.645 -146.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M836.056-2182.607c0-.176,0-.353,0-.529a.317.317,0,0,1,.312-.337.318.318,0,0,1,.328.337q.006.529,0,1.057a.323.323,0,0,1-.328.339.327.327,0,0,1-.312-.34c0-.01,0-.021,0-.031Q836.056-2182.358,836.056-2182.607Z",
    transform: "translate(-122.659 -210.973)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/Tickets.2e97248db54da225dc94aa5e21bdb286.svg";
export { ForwardRef as ReactComponent };